import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import pagarme from "pagarme";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MaskedInput from 'react-maskedinput'
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css'

import projetoCapa from "../../assets/img/icon-projeto-capa.png";
import leiaUmPouco from "../../assets/img/icon-leia-um-pouco.png";
import CardImage from "../../assets/svg/credit-card-icon-verm.svg";

import Modal from "../Modal";

import { getAuthorByName } from "../../services/Author";
import { getBookBySlug } from "../../services/Book";
import encriptionKey from '../../config/pgk.js'
import "./BookDetails.css";

import { Creators as LoaderActions } from "../../store/ducks/loader";


const baseUrl = "https://a5-dashboard.herokuapp.com";
// const baseUrl = "http://localhost:2813";

 class BookDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // book: this.props.data.data || {},
      book: {},
      author: {},
      modalOpen: false,
      modalOpenResult: false,
      name: "",
      email: "",
      amount: 1,
      valueBase: "",
      isValid: false,

      name_card: '',
      number_card: '',
      expiry: '',

    };
    this.handleClickDecrement = this.handleClickDecrement.bind(this);
    this.handleClickIncrement = this.handleClickIncrement.bind(this);
  }
  async componentDidMount() {
      const { isLoading } = this.props;
      const url = document.location.href.split('/')[4];
      isLoading(true);
      try {
        const bookData = await getBookBySlug(url);
        const { book } = bookData.data;
        const { author } = bookData.data.book[0];
        const authorData = await getAuthorByName(author);
        isLoading(false);
        const priceModified = book[0].price.toFixed(2).replace('.', ',');
        book[0].price = priceModified;
        await this.setState({ book: book[0], author: authorData.data[0], valueBase: priceModified});
        await console.log(this.state.book);
      } catch (error) {
        isLoading(false);
        console.log(error, 'Erro');
      }
  }

  notify = (message) => toast(message);

  async getCep() {
    const { zipcode } = this.state
    if(zipcode.includes('-') || zipcode.length <= 7 || zipcode.length > 8) {
      alert('Corrija o CEP para prosseguir');
    } else {
      if(zipcode.length === 8) {
        try {
          const response = await axios.get(`https://viacep.com.br/ws/${zipcode}/json/`);
          const { bairro, localidade, logradouro, uf } = response.data;
          await this.setState({
            neighborhood: bairro,
            city: localidade,
            street: logradouro,
            state: uf,
            zipcode: zipcode
          });
        } catch (err) {
          console.log(err);
        }
      }
    }
  }

  // async sendInformations() {
  //   const { name, email, amount, title, author, authors, price } = this.state.book;
  //   const json = { name, email, amount, author, authors, title, price };
    // await axios
    //   .post(`${baseUrl}/payment`, json)
    //   .then(async response => {
    //       console.log(response, 'Response from pagar.me');
    //      await this.setState({ modalOpenResult: true, titleResult: 'Obrigado', messageResult: 'Enviamos um email para você com todas as informações da sua compra' });
    //   })
    //   .catch( async (error) => {
    //     console.log(error);
    //     await this.setState({ modalError: true });
    //     await this.setState({ modalOpenResult: true, titleResult: 'Erro', messageResult: 'Verifique se as informações estão corretas e tente novamente!' });
    //   });
  // }

  async payment() {
    const { isLoading } = this.props;
    await this.setState({ modalOpen: !this.state.modalOpen });
    isLoading(true);
    const { amount, name, phone, email, cpf, birthday, zipcode, state, city, street, street_number, neighborhood } = this.state;
    const { title, author, price } = this.state.book;
    const { name_card, number_card, expiry, cvv } = this.state;
    const modifyPrice = price.replace(",", "");

    if(!name || !phone || !email || !cpf || !birthday || !zipcode || !state || !city || !street || !street_number || !neighborhood, !name_card, !number_card, !expiry, !cvv) {
      alert('Verifique se todos os campos foram preenchidos');
      await this.setState({ modalOpen: !this.state.modalOpen });
      isLoading(false)
    } else {
      const amountPrice = modifyPrice;

      const card = {
        card_number: String(number_card),
        card_holder_name: String(name_card),
        card_cvv: String(cvv),
        card_expiration_date: String(expiry)
      };

      console.log(card, 'MY CARD');
      const a = new Date().getTime();

      const customer = {
        external_id: String(a),
        name,
        type: "individual",
        country: "br",
        email,
        documents: [
          {
            "type": "cpf",
            "number": cpf
          }
        ],
        phone_numbers: [phone],
        birthday
      }

      const billing = {
          name,
          ...address
        }

      const address = {
         country: "br",
         state,
         city,
         neighborhood,
         street,
         street_number,
         zipcode
      };

      const shipping = {
        name,
        delivery_date: new Date(),
        expedited: true,
        ...address
      };

      const items = [
        {
          id: new Date().getTime(),
          title,
          quantity: this.state.amount,
          unit_price: Number(amountPrice / this.state.amount),
          tangible: true
        }
      ];

      const formData = {
        title,
        author,
        email,
        price,
        amountPrice,
        amount,
        customer,
        billing,
        address,
        shipping,
        installments: 1,
        items
      };

      try {
        const client = await pagarme.client.connect({
          encryption_key: encriptionKey
        });

        const card_hash = await client.security.encrypt(card);

        const response = await axios.post(`${baseUrl}/payment`, { formData, card_hash });
        await this.setState({ modalOpenResult: true, titleResult: 'Obrigado', messageResult: 'Enviamos um email para você com todas as informações da sua compra' });
        await this.setState({ name: '', phone: '', email: '', cpf: '', birthday: '', zipcode: '', state: '', city: '', street: '', street_number: '', neighborhood: '' });
        isLoading(false);
        console.log(response);
      } catch (err) {
        console.log(err);
        await this.setState({ modalOpen: !this.state.modalOpen, modalOpenResult: !this.state.modalOpenResult, titleResult: 'Erro', messageResult: 'Erro ao processar a sua compra, se o erro persistir envie um email para: contato@a5editora.com.br' });
        isLoading(false);
      }
    }


  }


  notify = param => toast(param);
  async handleCloseModal() {
    await this.setState({ modalOpen: false });
  }
  async handleCloseModalResult() {
    await this.setState({ modalOpenResult: false });
  }
  async handleOpenModal() {
    await this.setState({ modalOpen: true });
    // this.notify('ESTAMOS TRABALHANDO PARA MELHORAR A SUA COMPRA')
  }

  //
  // async captureTransaction(data) {
  //   const { token, modifyPrice } = data;
  //   try {
  //     const response = await axios.post(`${baseUrl}/cpv`, { token, amount: modifyPrice });
  //     console.log(response, 'Resp');
  //   } catch (err) {
  //     console.log('ERRO NA CAPTURA', err);
  //   }
  // }

  // async payment(data) {
  //     if(this.state.name && this.state.email !== "" && this.state.email.includes("@")) {
  //       await this.setState({ modalOpen: false });
  //       const { price, title, _id } = this.state.book;
  //       const modifyPrice = price.replace(",", "");
  //       var checkout = new window.PagarMeCheckout.Checkout({
  //         encryption_key: encriptionKey,
  //         success: async (data) => {
  //           await this.sendInformations();
  //           console.log(data, 'data');
  //           const { token } = data;
  //           console.log(token);
  //           const obj = { token, modifyPrice }
  //           await this.captureTransaction(obj);
  //         },
  //         error: function(err) {
  //           console.log(err, 'ERRO AQUI NO PAGAMENTO');
  //           this.notify("Ocorreu um erro ao realizar o seu pagamento!");
  //         }
  //       });
  //       var params = {
  //         "amount": Number(modifyPrice),
  //         "buttonText":"Pagar",
  //         "customerData":"true",
  //         "paymentMethods":"credit_card",
  //         "maxInstallments":2,
  //         "uiColor":"#bababa",
  //         "postbackUrl":"requestb.in/1234",
  //         "createToken":"true",
  //         "interestRate":12,
  //         "freeInstallments":3,
  //         "defaultInstallment":5,
  //         "headerText":"Título",
  //           items: [
  //             {
  //               id: _id,
  //               title: title,
  //               unit_price: modifyPrice,
  //               quantity: this.state.amount,
  //               tangible: "true"
  //             }
  //           ]
  //       };
  //       // var params = {
  //       //   uiColor: "#ffb52f",
  //       //   amount: Number(modifyPrice),
  //       //   buttonText: "Pagar",
  //       //   buttonClass: "botao-pagamento",
  //       //   customerData: "true",
  //       //   maxInstallments: 2,
  //       //   createToken: "true",
  //       //   paymentMethods: "credit_card",
  //       //   items: [
  //       //     {
  //       //       id: _id,
  //       //       title: title,
  //       //       unit_price: modifyPrice,
  //       //       quantity: this.state.amount,
  //       //       tangible: "true"
  //       //     }
  //       //   ]
  //       // };
  //       console.log(params, 'MY PARAMS');
  //       checkout.open(params);
  //     }
  //      else {
  //         this.notify("Verifique se os campos estão corretos!");
  //     }
  //
  // }
  async handleClickDecrement() {
    const { amount, book, valueBase } = this.state;
    if (amount !== 1) {
      await this.setState({ amount: amount - 1 });
      let { price } = book;
      price = parseFloat(price.replace(",", "."));
      price = (
        parseFloat(valueBase.replace(",", ".")) * this.state.amount
      ).toFixed(2);
      price = price.toString().replace(".", ",");
      book.price = price;
      await this.setState({ book: book });
    }
  }
  async handleClickIncrement() {
    const { amount, book, valueBase } = this.state;
    await this.setState({ amount: amount + 1 });
    let { price } = book;
    price = parseFloat(price.replace(",", "."));
    price = (
      parseFloat(valueBase.replace(",", ".")) * this.state.amount
    ).toFixed(2);
    price = price.toString().replace(".", ",");
    book.price = price;
    await this.setState({ book: book });
  }

  render() {
    const { modalOpen, modalOpenResult,  amount, valueBase, titleResult, messageResult } = this.state;
    return (
      <div id="BookDetails" className="container-fuild bookdetails">
        <ToastContainer
          toastClassName="toastcontainer"
          progressClassName="toast-progress"
        />
        <div className="container mb-5">
          <h3 className="bookdetails__title">{this.state.book.category}</h3>
          <h3 className="bookdetails__category">{this.state.book.title}</h3>

          <div className="row">
            <div className="col-12 col-md-7 col-lg-7 col-xl-5">
              <img
                className="book-details-bookImage"
                src={this.state.book.image}
                alt=""
              />
            </div>

            <div className="col-12 col-md-5 col-lg-5 col-xl-7">
              <div className="book-details-info">
                <div>
                  {
                    this.state.book.authors ? (
                      <p className="book-data-details">
                        Autores:{" "}
                        <strong>
                          {" "}
                          <span
                            className="color-default-1 name-author"
                            style={{ fontWeight: "bold" }}
                          >
                            {this.state.book.authors}
                          </span>
                        </strong>
                      </p>
                    ) : (
                      <p className="book-data-details">
                        Autor(a):{" "}
                        <strong>
                          {" "}
                          <span
                            className="color-default-1 name-author"
                            style={{ fontWeight: "bold" }}
                          >
                            {this.state.book.author}
                          </span>
                        </strong>
                      </p>
                    )
                  }
                  <p className="book-data-details">
                    Editora:{" "}
                    <span>
                      {" "}
                      <strong>{this.state.book.editora}</strong>{" "}
                    </span>
                  </p>
                </div>
              </div>
              <div className="book-details-info">
                <div>
                  <p className="book-data-details">
                    {" "}
                    Formato: <strong>{this.state.book.format}</strong>
                  </p>
                  <p className="book-data-details">
                    {" "}
                    Tamanho: <strong>{this.state.book.size}</strong>
                  </p>
                  <p className="book-data-details">
                    {" "}
                    Peso: <strong>{this.state.book.weight}</strong>
                  </p>
                  <p className="book-data-details">
                    {" "}
                    Páginas: <strong>{this.state.book.pages}</strong>
                  </p>
                  <p className="book-data-details">
                    {" "}
                    Data da publicação: <strong>{this.state.book.date}</strong>
                  </p>
                  <p className="book-data-details">
                    {" "}
                    Ano: <strong>{this.state.book.year}</strong>
                  </p>
                  <p className="book-data-details">
                    {" "}
                    Edição: <strong>{this.state.book.edition}</strong>
                  </p>
                  <p className="book-data-details">
                    {" "}
                    Idioma: <strong>{this.state.book.language}</strong>
                  </p>
                  <p className="book-data-details">
                    {" "}
                    ISBN: <strong>{this.state.book.isbn}</strong>
                  </p>
                </div>
              </div>
              <div className="book-details-download">
                <span className="color-default-2">
                  <img src={leiaUmPouco} alt="" />
                  Leia um pouco
                </span>
                <span className="color-default-2">
                  <img src={projetoCapa} alt="" />
                  Projeto de capa
                </span>
              </div>
              <div className="book-details-amount">
                <button
                  className="book-details-amount__decrement"
                  onClick={this.handleClickDecrement}
                >
                  -
                </button>
                <span className="book-details-amount__value">{amount}</span>
                <button
                  className="book-details-amount__increment"
                  onClick={this.handleClickIncrement}
                >
                  +
                </button>
              </div>
              <div className="book-details-price">
                <span className="book-details-price-value">
                  R$ <strong>{this.state.book.price}</strong>{" "}
                </span>
                <span className="book-details-price-portion">
                  {`Em até 2x de ${(
                    parseFloat(this.state.book.price) / 2
                  )
                    .toFixed(2)
                    .toString()
                    .replace(".", ",")} sem juros`} <span className="titleFrete">(Frete incluso)</span>
                </span>
                <button
                  onClick={() => this.handleOpenModal()}
                  className="book-details-buy-button"
                >
                  COMPRAR
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="container description description-one spacer">
          <div className="container">
            <div className="">
              <div className="">
                <h3 className="bookdetails__description description_text">Descrição</h3>
              </div>
              <div
                className="container_descrip"
              >
                <p className="sinopse">{this.state.book.sinopse}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="container description description-one spacer deliver">
          <div className="container">
            <div className="">
              <div className="">
                <h3 className="bookdetails__description description_text">Entrega e pagamento</h3>
              </div>
              <div
                className="container_descrip"
              >
              <p className="sinopse">
                 Aceitamos pagamento por Cartão de crédito e débito ( Visa; Master; Elo; Amex; Hiper, JCB, Dinners & Discover)
                 Já está incluso no valor do livro o frete na modalidade encomenda normal com registro módico. Segundo os correios
                 o prazo de entrega é de até 15 dias úteis. Este serviço só se diferencia do PAC por que o acompanhamento só pode
                 ser visualizado na saída e na chegada do livro ao destino.
               </p>
              </div>
            </div>
          </div>
        </div>
        {
          /*


        <div className="container description description-one">
          <div className="container">
            <div className="row container-row">
              <div className="col-12 col-md-4">
                <h3 className="bookdetails__description deliver_payment">Entrega e Pagamento</h3>
              </div>
              <div
                className="container_descrip"
              >
                <p className="paragraph">
                   Aceitamos pagamento por Cartão de crédito e débito ( Visa; Master; Elo; Amex; Hiper, JCB, Dinners & Discover)
                   Já está incluso no valor do livro o frete na modalidade encomenda normal com registro módico. Segundo os correios
                   o prazo de entrega é de até 15 dias úteis. Este serviço só se diferencia do PAC por que o acompanhamento só pode
                   ser visualizado na saída e na chegada do livro ao destino.
                   <strong> Caso opte por PAC o custo médio é de R$ 16,00.
                   Caso opte por Sedex e a depender da região o custo é de até R$ 50,00</strong>
                 </p>

              </div>
            </div>
          </div>
        </div>
      */}
        <div className="container book-details-auth spacer">
          <div className="book-details-auth-image">
            <img src={this.state.author.image ? this.state.author.image : 'https://res.cloudinary.com/uxmob/image/upload/v1555641916/phtxz4ktstdldlnjwgbq.jpg'} alt={this.state.book.title} />
          </div>
          <div className="book-details-auth-description">
            <div style={{ height: "auto" }} className="book-details-auth-bio">
              <h3 className="nameAuthor">{this.state.author.nome} </h3>
              <p className="bio">{this.state.author.biografia}</p>
            </div>
          </div>
        </div>
          <Modal open={modalOpen} onClose={() => this.handleCloseModal()}>
            <div className="centered">
            <div className="bookdetails__modalContainer">
              <h3 className="bookdetails__modalContainer__title title-h3">
                Etapa de pagamento
              </h3>
              <div className="row">
                <div className="col-xl-12">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="name"
                    >
                      NOME
                    </label>
                    <input
                      id="name"
                      type="text"
                      value={this.state.name}
                      onChange={name =>
                        this.setState({ name: name.target.value })
                      }
                      className="form-control bookdetails__modalContainer__input"
                    />
                  </div>
                </div>
                <div className="col-xl-6">
                    <div className="form-group">
                        <label className="contact-label" htmlFor="celular">CELULAR</label>
                        <MaskedInput
                            required
                            mask="(11) 1 1111-1111"
                            value={this.state.phone}
                            className="form-control contact-input"
                            id="celular"
                            onChange={(phone) => this.setState({ phone: phone.target.value })}
                        />
                    </div>
                </div>
                <div className="col-xl-12">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="lastName"
                    >
                      EMAIL
                    </label>
                    <input
                      id="lastName"
                      type="email"
                      required
                      value={this.state.email}
                      onChange={email =>
                        this.setState({ email: email.target.value })
                      }
                      className="form-control bookdetails__modalContainer__input"
                    />
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="lastName"
                    >
                      CPF:
                    </label>
                    <input
                        required
                        value={this.state.cpf}
                        className="form-control contact-input"
                        id="cpf"
                        onChange={(cpf) => this.setState({ cpf: cpf.target.value })}
                    />
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="lastName"
                    >
                      DATA DE NASCIMENTO:
                    </label>
                    <input
                      id="lastName"
                      type="date"
                      required
                      value={this.state.birthday}
                      onChange={birthday =>
                        this.setState({ birthday: birthday.target.value })
                      }
                      className="form-control bookdetails__modalContainer__input"
                    />
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="form-group">
                    <Cards
                      cvc={this.state.cvc}
                      expiry={this.state.expiry}
                      focused={this.state.focus}
                      name={this.state.name_card}
                      number={this.state.number_card}
                    />
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="lastName"
                    >
                      NOME NO CARTÃO:
                    </label>
                    <input
                      id="lastName"
                      type="text"
                      required
                      value={this.state.name_card}
                      onChange={name_card =>
                        this.setState({ name_card: name_card.target.value })
                      }
                      className="form-control bookdetails__modalContainer__input"
                    />
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="lastName"
                    >
                      NÚMERO DO CARTÃO:
                    </label>
                    <input
                      id="lastName"
                      type="text"
                      required
                      maxLength="16"
                      value={this.state.number_card}
                      onChange={number_card =>
                        this.setState({ number_card: number_card.target.value })
                      }
                      className="form-control bookdetails__modalContainer__input"
                    />
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="lastName"
                    >
                      DATA DE EXPIRAÇÃO:
                    </label>
                    <input
                      id="lastName"
                      type="text"
                      maxLength="4"
                      required
                      value={this.state.expiry}
                      onChange={expiry =>
                        this.setState({ expiry: expiry.target.value })
                      }
                      className="form-control bookdetails__modalContainer__input"
                    />
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="lastName"
                    >
                      CÓDIGO DE SEGURANÇA:
                    </label>
                    <input
                      id="lastName"
                      type="text"
                      required
                      maxLength="3"
                      value={this.state.cvv}
                      onChange={cvv =>
                        this.setState({ cvv: cvv.target.value })
                      }
                      className="form-control bookdetails__modalContainer__input"
                    />
                  </div>
                </div>

                <div className="col-xl-12 centered-text">
                  <h6 className="text-center">DADOS PARA ENTREGA</h6>
                </div>

                <div className="col-xl-6">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="lastName"
                    >
                      CEP ( sem o - )
                    </label>
                    <input
                      id="lastName"
                      type="number"
                      required
                      maxLength="8"
                      onChange={zipcode => this.setState({ zipcode: zipcode.target.value })}
                      onBlur={(zp) => this.getCep(zp)}
                      value={this.state.zipcode}
                      className="form-control bookdetails__modalContainer__input"
                    />
                  </div>
                </div>

                <div className="col-xl-6">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="lastName"
                    >
                      ESTADO
                    </label>
                    <input
                      id="lastName"
                      type="text"
                      required
                      maxLength="2"
                      value={this.state.state}
                      onChange={state =>
                        this.setState({ state: state.target.value })
                      }
                      className="form-control bookdetails__modalContainer__input"
                    />
                  </div>
                </div>

                <div className="col-xl-6">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="lastName"
                    >
                      CIDADE
                    </label>
                    <input
                      id="lastName"
                      type="text"
                      required
                      value={this.state.city}
                      onChange={city =>
                        this.setState({ city: city.target.value })
                      }
                      className="form-control bookdetails__modalContainer__input"
                    />
                  </div>
                </div>

                <div className="col-xl-6">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="lastName"
                    >
                      RUA
                    </label>
                    <input
                      id="lastName"
                      type="text"
                      required
                      value={this.state.street}
                      onChange={street =>
                        this.setState({ street: street.target.value })
                      }
                      className="form-control bookdetails__modalContainer__input"
                    />
                  </div>
                </div>

                <div className="col-xl-6">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="lastName"
                    >
                      NÚMERO DA RUA
                    </label>
                    <input
                      id="lastName"
                      type="text"
                      required
                      value={this.state.street_number}
                      onChange={street_number =>
                        this.setState({ street_number: street_number.target.value })
                      }
                      className="form-control bookdetails__modalContainer__input"
                    />
                  </div>
                </div>

                <div className="col-xl-6">
                  <div className="form-group">
                    <label
                      className="bookdetails__modalContainer__label"
                      htmlFor="lastName"
                    >
                      BAIRRO
                    </label>
                    <input
                      id="lastName"
                      type="text"
                      required
                      value={this.state.neighborhood}
                      onChange={neighborhood =>
                        this.setState({ neighborhood: neighborhood.target.value })
                      }
                      className="form-control bookdetails__modalContainer__input"
                    />
                  </div>
                </div>

                <div style={{ margin: "0 auto" }}>
                  <button
                    className="bookdetails__modalContainer__button"
                    onClick={() => this.payment()}
                  >
                    Próximo
                  </button>
                </div>
              </div>
            </div>
        </div>
      </Modal>
          <Modal mt={true} open={modalOpenResult} onClose={() => this.handleCloseModalResult()}>
            <div className="modal_centered">
              <h3>{titleResult}</h3>
              <p>{messageResult}</p>
            </div>
          </Modal>
      </div>
    );
  }
}



const mapDispatchToProps = dispatch =>
  bindActionCreators(LoaderActions, dispatch);

export default connect(
  null,
  mapDispatchToProps
)(BookDetails);



// WEBPACK FOOTER //
// ./src/components/BookDetails/BookDetails.js